import axios from 'axios';

const api = axios.create({
    baseURL: '/admin/role-model/'
});

export const getRoleModels = () => api.get(`show`);